<div class="btr-details">
    <ng-container *ngIf="isAddMode && group">
        <div class="btr-details__grid" [formGroup]="group">
            <ds-select
                [id]="'btr_trip'"
                formControlName="tripID"
                label="Trip # *"
                [placeholder]="tripPlaceholder"
                [isSearchable]="true"
                [options]="tripOptions"
                [compareWith]="compareById"
            >
                <mat-error>{{ fieldErrors.tripID }}</mat-error>
            </ds-select>

            <ds-select
                [id]="'btr_customer'"
                class="btr-details__wide"
                formControlName="customer"
                label="Customer *"
                [placeholder]="customerPlaceholder"
                [isSearchable]="true"
                [options]="customerOptions"
                [compareWith]="compareById"
            >
                <mat-error>{{ fieldErrors.customer }}</mat-error>
            </ds-select>

            <ds-select
                [id]="'btr_air_vendor'"
                formControlName="airVendor"
                label="Air vendor *"
                [placeholder]="airVendorPlaceholder"
                [isSearchable]="true"
                [options]="airVendorOptions"
                [compareWith]="compareById"
            >
                <mat-error>{{ fieldErrors.airVendor }}</mat-error>
            </ds-select>

            <ds-select
                [id]="'btr_tail_number'"
                formControlName="tailNumber"
                label="Tail number *"
                [placeholder]="tailPlaceholder"
                [isSearchable]="true"
                [options]="tailOptions"
                [compareWith]="compareById"
            >
                <mat-error>{{ fieldErrors.tailNumber }}</mat-error>
            </ds-select>
        </div>
    </ng-container>

    <dl class="btr-details__grid btr-details__facts">
        <ng-container *ngFor="let fact of visibleFacts; trackBy: trackByLabel">
            <div class="btr-details__fact" [class.btr-details__wide]="fact.isWide">
                <dt><ds-text size="sm" weight="medium" theme="secondary" [text]="fact.label"></ds-text></dt>
                <dd><ds-text size="md" weight="regular" theme="primary" [text]="fact.value"></ds-text></dd>
            </div>
        </ng-container>
    </dl>
</div>
